<script lang="ts">
  import Button from '$components/ui/button.svelte';
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import { cn } from '$lib/utils';
  import { getAnchorFromCmsLink } from '$lib/utils/cms';
  import type { CenteredTitleStoryblok } from '$types/bloks';

  export let block: CenteredTitleStoryblok;
  export let as: 'h1' | 'h2' = 'h2';
</script>

<div
  use:storyblokEditable={block}
  class="relative w-fit text-center mx-auto pt-16 pb-2 px-2 lg:pt-[72px] lg:pb-8 lg:px-8"
>
  {#if block.title}
    <svelte:element
      this={as}
      class={cn(
        'relative text-8xl font-semibold max-w-[358px] md:max-w-[680px]',
        as === 'h1' && 'max-w-[358px] md:max-w-[735px]'
      )}
    >
      {block.title}
    </svelte:element>
  {/if}

  {#if block.description}
    <p
      class={cn(
        'mt-3 text-xl max-w-[358px] md:max-w-[680px]',
        as === 'h1' && 'max-w-[358px] md:max-w-[735px]'
      )}
    >
      {block.description}
    </p>
  {/if}

  {#if block.cta?.[0]}
    {@const { href, rel, target } = $getAnchorFromCmsLink(block.cta?.[0].link)}
    <Button as="a" variant="accent" size="md" class="mt-9" {href} {rel} {target}>
      {block.cta[0].label}
    </Button>
  {/if}
</div>
